export * from './html-editor-personalization-plugin.component';
